export function getServicedeskMailto(subject: string, body: string): string {
  return `mailto:support@ranawaterintelligence.com?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
}
